/* Osmanlı Doğal Taş — Reklam/QR takibi (global, tema geneli).
   utm_source ile giren ziyaretçiyi yakalar → "giris" beacon'u;
   herhangi bir /odt/v1/<modul>/kaydet çağrısını görünce → "analiz" beacon'u (test_kod+tur).
   Sepet/satın panelde analiz kaydından (sepete_at/siparis_id) test_kod ile bağlanır.
   Not: fetch güvenli sarmalanır (yalnız beacon ekler, orijinal davranışı değiştirmez). */
(function () {
  "use strict";
  var API = "https://www.osmanliyonetim.com/wp-json/odt/v1/qr/olay";
  var TTL = 30 * 24 * 60 * 60 * 1000; // 30 gün atıf penceresi

  function qs(k) { try { return new URLSearchParams(location.search).get(k) || ""; } catch (e) { return ""; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function sid() {
    var s = ls("odt_sid");
    if (!s) { s = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); ls("odt_sid", s); }
    return s;
  }
  function utm() {
    // Herhangi bir utm kaynağını attribute et; panelde hangi kaynakların GÖRÜNECEĞİ sunucudaki izin listesiyle süzülür.
    try { var u = JSON.parse(ls("odt_utm") || "null"); if (u && u.kaynak && (Date.now() - (u.t || 0) < TTL)) return u; } catch (e) {}
    return null;
  }
  function beacon(olay, extra) {
    var u = utm(); if (!u) return;
    var body = { sid: sid(), kaynak: u.kaynak, kampanya: u.kampanya || "", olay: olay, sayfa: location.pathname };
    if (extra) for (var k in extra) body[k] = extra[k];
    try {
      fetch(API, { method: "POST", mode: "cors", keepalive: true,
        headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).catch(function () {});
    } catch (e) {}
  }

  // 1) Landing: utm_source varsa sakla + "giris". Panelde yalnız izin listesindeki kaynaklar görünür (sunucu süzer).
  var src = qs("utm_source");
  if (src) {
    ls("odt_utm", JSON.stringify({ kaynak: src.slice(0, 60), kampanya: qs("utm_campaign").slice(0, 60), medium: qs("utm_medium").slice(0, 20), t: Date.now() }));
    beacon("giris");
  }

  /* 2) Analiz tamamlandı: /odt/v1/<modul>/kaydet çağrısını yakala.
        a) utm ile gelmişse -> panele "analiz" beacon'u
        b) HER ziyaretçide  -> Shopify olay hattına "test_tamamlandi"
           (Meta pikseli sanal alanda; Özel Piksel bu olaya abone olur)

     ⚠️ ESKİ SÜRÜM window.fetch'i SARMALIYORDU VE ÇALIŞMIYORDU.
     2026-09-01'de ölçüldü: sayfada başka bir uygulama window.fetch'i kendi
     sarmalayıcısıyla DEĞİŞTİRİYOR ve bizimki zincirden düşüyor. Kanıt:
     /kaydet çağrısı 200 dönüyor, Shopify.analytics.publish mevcut, ama
     window.fetch.toString() içinde "test_tamamlandi" YOK — yani olay
     üretimde HİÇ yayınlanmadı. Piksel yapıştırılsaydı hiçbir şey almazdı.

     Çözüm: sarmalayıcı yarışına girmek yerine isteği AĞ KATMANINDA dinle.
     PerformanceObserver, fetch'i kim sararsa sarsın her isteği görür.
     Yedek olarak hafif bir fetch sarmalayıcısı da duruyor; ikisi de aynı
     `gonderildi` defterini kullandığı için çift gönderim olmaz. */
  var gonderildi = {};

  function analizTamam(ad) {
    var m = String(ad || "").match(/\/odt\/v1\/([a-z\-]+)\/kaydet/);
    if (!m) return;
    var modul = m[1];
    if (gonderildi[modul]) return;
    gonderildi[modul] = 1;
    /* Test kodu modül tarafından set ediliyor; istek bitmiş olsa da kod
       birkaç yüz ms sonra yazılabiliyor — kısa bir soluk bırak. */
    setTimeout(function () {
      var kod = "";
      try {
        kod = (window.ODT_TEST_KOD ||
               (window.ODTTasarla && window.ODTTasarla.S && window.ODTTasarla.S.kod) || "") + "";
      } catch (e) {}
      if (utm()) beacon("analiz", { tur: modul, test_kod: kod });
      try {
        if (window.Shopify && window.Shopify.analytics &&
            typeof window.Shopify.analytics.publish === "function") {
          window.Shopify.analytics.publish("test_tamamlandi",
            { tur: modul, test_kod: kod, sayfa: location.pathname });
        }
      } catch (e) {}
    }, 500);
  }

  if (window.PerformanceObserver) {
    try {
      var po = new PerformanceObserver(function (liste) {
        var g = liste.getEntries();
        for (var i = 0; i < g.length; i++) analizTamam(g[i].name);
      });
      /* buffered:true → gözlemci kurulmadan önce biten istekler de gelir. */
      po.observe({ type: "resource", buffered: true });
    } catch (e) {
      try { new PerformanceObserver(function (l) {
        l.getEntries().forEach(function (x) { analizTamam(x.name); });
      }).observe({ entryTypes: ["resource"] }); } catch (e2) {}
    }
  }

  /* Yedek yol (PerformanceObserver yoksa ya da kaynak girdisi gelmezse). */
  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function (url, opts) {
      try {
        var us = (typeof url === "string") ? url : (url && url.url) || "";
        analizTamam(us);
      } catch (e) {}
      return _f.apply(this, arguments);
    };
  }
})();
